import React, { type FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import { type EnergyAudit } from 'interfaces/EnergyAudit.interface';
import { formatDecimalSeparator } from 'utils/formatters/number/numberUtils';

interface KPIItemProps {
  label: string;
  shouldRound?: boolean;
  value?: number;
  isFetching?: boolean;
  addorment?: string;
  decimalScale?: number;
}

const EnergyAuditKPIItem: FC<KPIItemProps> = ({
  label,
  shouldRound = true,
  value,
  isFetching,
  addorment,
  decimalScale = 0,
}) => (
  <div className="flex justify-between items-center flex-1 bg-gray-10 p-4">
    <span className="text-gray-50 text-sm font-sans">{label}</span>
    <span className="text-2xl font-medium text-gray-60 flex items-end gap-1 font-sans">
      {isFetching ? (
        <Skeleton width={80} height={32} />
      ) : (
        <>
          {formatDecimalSeparator({
            value: shouldRound ? Math.round(Math.abs(value ?? 0)) : value ?? 0,
            decimalScale,
          })}
          <span className="text-base">{addorment}</span>
        </>
      )}
    </span>
  </div>
);

const EnergyAuditKPICards: FC<{
  data?: EnergyAudit;
  isFetching?: boolean;
}> = ({ data, isFetching = false }) => (
  <div className="flex flex-col gap-4">
    <div className="flex gap-4">
      <EnergyAuditKPIItem
        label="Investment Cost"
        value={data?.investment_cost}
        addorment="€"
        isFetching={isFetching}
      />
      <EnergyAuditKPIItem
        label="Payback period"
        shouldRound={false}
        value={data?.payback_time_years}
        addorment="year"
        decimalScale={1}
        isFetching={isFetching}
      />
    </div>
    <div className="flex gap-4">
      <EnergyAuditKPIItem
        label="Annual savings"
        value={data?.calculation_details?.savings_euro_per_year}
        addorment="€"
        isFetching={isFetching}
      />
      <EnergyAuditKPIItem
        label="Energy savings"
        shouldRound={false}
        value={data?.calculation_details?.savings_per_year}
        addorment="kWh"
        decimalScale={1}
        isFetching={isFetching}
      />
    </div>
  </div>
);

export default EnergyAuditKPICards;
